angular.module('impactx.rfx').controller('RFXSupplierSmartFormItemCtrl', RFXSupplierSmartFormItemCtrl);

RFXSupplierSmartFormItemCtrl.$inject = [
    '$scope',
    'dataGen',
    '$mdDialog',
    'SmartFormTemplateCache',
    'TranslationService',
    'AppConfiguration'
];

function RFXSupplierSmartFormItemCtrl($scope, dataGen, $mdDialog, SmartFormTemplateCache, TranslationService, AppConfiguration) {
    var self = this;
    self.isSupplierDialog = true;
    self.itemCopy = angular.copy(self.item, self.itemCopy);
    self.trns.save = TranslationService.get('accept');
    self.trns.abort = TranslationService.get('abort');
    self.trns.continue = TranslationService.get('forward');
    self.freeformOfferLotSelect = AppConfiguration.get('freeformOfferLotSelect');
    self.trns.required = TranslationService.get('required');
    self.oldContractSelected = 0;
    self.selectCurrency = !self.itemCopy.csc;
    activate();

    self.getSmartForm = function (selection) {
        if (selection) {
            dataGen.getData({}, {sftId: selection.id}, '/rfx/supplier/item/smartform').then(function (response) {
                if (impactX.isDefined(response, 'data.smartForm')) {
                    if (impactX.isDefined(self, 'itemCopy.smartForm.identifier')) {
                        SmartFormTemplateCache.removeForm(self.itemCopy.smartForm.identifier);
                    }
                    self.itemCopy.smartForm = response.data.smartForm;
                    self.itemCopy.selectedSmartFormTemplate = selection;
                    self.itemCopy.unit.selected = impactX.isDefined(response, 'data.smartForm.defaultUnit.selected');
                }
            });
        }
    };

    self.save = function () {
        removeSelection();
        self.itemCopy.id = self.itemCopy.id || 0;
        SmartFormTemplateCache.removeForm(self.itemCopy.smartForm.identifier);

        if (self.itemCopy.lot) {
            delete self.itemCopy.csc;
        }
        dataGen.postAsForm({}, {smartForm: self.itemCopy.smartForm}, "/rfx/supplier/item/smartform/attributes").then(function (data) {
            self.itemCopy.smartFormAttributes = data.data.smartFormAttributes;
            $mdDialog.hide(self.itemCopy);
        });
    };

    self.abort = function () {
        removeSelection();
        if (self.itemCopy && self.itemCopy.smartForm) {
            SmartFormTemplateCache.removeForm(self.itemCopy.smartForm.identifier);
        }
        $mdDialog.cancel();
    };

    self.onContractSelect = function(selected) {
        if(selected && selected.id != self.oldContractSelected) {
            var tempScope = {};
            dataGen.getData(tempScope, {cscId: selected.id, supplierSide: true, orderCOMId : self.itemCopy.orderCOMId}, "/rfx/contract/updatedata").then(function() {
                if (self.selectCurrency) {
                    if (tempScope.data.cscCurrencySelected && tempScope.data.cscCurrencySelected.selected) {
                        for (var i = 0; i < self.itemCopy.price.currency.entries.length; i++) {
                            if (self.itemCopy.price.currency.entries[i].id === tempScope.data.cscCurrencySelected.selected.id) {
                                self.itemCopy.price.currency.selected = self.itemCopy.price.currency.entries[i];
                                self.selectCurrency = false;
                            }
                        }
                    }
                }
            });
            self.oldContractSelected = selected.id;
        }
    };

    function removeSelection() {
        if (self.smartFormTemplates) {
            self.smartFormTemplates.selected = undefined;
        }
    }

    function activate() {
        var sfiId = impactX.isDefined(self, 'itemCopy.sfiId');
        if (!!sfiId && sfiId > 0) {
            // if there is a sfi-id and a smartform object, then an existing one was changed.
            // so don't get fresh data from backend since this would overwrite the entered values
            if (!impactX.isDefined(self, 'itemCopy.smartForm')) {
                dataGen.getData({}, {id: sfiId}, "/rfx/supplier/smartforminstance/view").then(function (data) {
                    var result = impactX.isDefined(data, 'data.smartForm');
                    if (result) {
                        self.itemCopy.smartForm = result;
                    }
                });
            }
        }
        else {
            var smartFormTitle = impactX.isDefined(self, 'itemCopy.smartForm.title');
            if (smartFormTitle && self.smartFormTemplates) {
                angular.forEach(self.smartFormTemplates.entries, function (template) {
                    if (template.value === smartFormTitle) {
                        self.smartFormTemplates.selected = template;
                    }
                })
            }
        }
    }
}